<template>
    <div class="card mb-5 mb-xxl-8">
      <!--begin::Body-->
      <div class="card-body pb-0">
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('shop.shop_configuration_stores') }}</h3>
          </div>
          <div class="card-toolbar" v-if="!shop?.archive">
            <a v-if="$can('boutique_store_config_create')"  @click="openAddModal" class="btn btn-sm btn-primary me-2">{{ $t('shop.add_stores_to_shop') }}</a>
            <!-- <a href="../../demo1/dist/.html" @click="openRemoveModal" class="btn btn-sm btn-danger me-2" data-bs-toggle="modal" data-bs-target="#kt_modal_remove_stores">{{ $t('shop.remove_stores_in_shop') }}</a> -->
          </div>

        </div>
        <div class="card-body">
          <!--begin::Layout-->
          <div class="row">
            <!--begin::Table-->
            <table class="table align-middle table-row-bordered fs-6 gy-3 "  id="kt_datatable_shop_stores">
              <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-100px">{{ $t('shop.store_name')}}</th>
                <th class="min-w-100px">{{ $t('action') }}</th>
              </tr>
              </thead>
            </table>
            <!--end::Table-->
          </div>
          <!--end::Layout-->
        </div>
      </div>

      <div class="modal fade" tabindex="-1" id="addStoresModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('shop.add_stores_to_shop') }}</h5>
              <!--begin::Close-->
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-2x"></span>
              </div>
              <!--end::Close-->
            </div>

            <div class="modal-body">
              <!--begin:Form-->
              <form id="kt_modal_add_form" @submit.prevent="addStoresInShopData" class="form" >
                <div class="d-flex flex-column mb-8 fv-row">
                  <label class="form-label">{{ $t('shop.select_stores') }}</label>
                  <div class="d-flex align-items-stretch h-100 mb-5">
                    <div class="flex-grow-1">
                      <select class="col form-select form-select-solid kt_select2" aria-describedby="basic-addon2" data-control="select2"
                              v-model="formAddStoresToShopData.stores"  name="addStores[]"
                              :data-placeholder="$t('shop.select_stores')" data-allow-clear="true" multiple="multiple">
                        <option></option>
                        <option v-for="store in stores" :key="store.id" :value="store.id" > {{ store.name }} </option>
                      </select>
                    </div>
                    <div data-bs-target="#storeModal" data-bs-toggle="modal"
                          class="cursor-pointer btn btn-light d-flex align-items-center justify-content-center border border-start-0" id="basic-addon2">
                        <i class="fas fa-plus fs-4"></i>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
                  <button type="submit" id="kt_submit_add_store" class="btn btn-sm btn-primary fw-bolder">
                    <span class="indicator-label">{{ $t('button.save') }}</span>
                    <span class="indicator-progress">{{  $t('loading') }}
                  <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                  </button>
                </div>
              </form>
              <!--end:Form-->
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" tabindex="-1" id="storeModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('store.create.title') }}</h5>
              <!--begin::Close-->
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-target="#addStoresModal" data-bs-toggle="modal" aria-label="Close">
                <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
                <!--end::Svg Icon-->
              </div>

              <!--end::Close-->
            </div>
            <div class="modal-body">
              <!--begin:Form-->
              <form @submit.prevent="createStoreData" id="kt_modal_new_target_form" class="form">

                <div class="d-flex flex-column mb-8 fv-row">
                  <!--begin::Label-->
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('store.form.name') }}</span>
                    <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                       title="Specify a target name for future usage and reference"></i>
                  </label>
                  <!--end::Label-->
                  <input type="text" class="form-control form-control-solid" v-model="formStore.name"
                         :placeholder="$t('store.form.name')" required />
                </div>

                <div class="d-flex flex-column mb-8 fv-row">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('store.form.address') }}</span>
                    <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                       title="Veuillez bien renseigner ce champ"></i>
                  </label>
                  <input type="text" class="form-control form-control-solid" v-model="formStore.address"
                         :placeholder="$t('store.form.address')" required />
                </div>

                <div class="d-flex flex-column mb-8 fv-row">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('store.form.telephone') }}</span>
                  </label>
                  <vue-tel-input @country-changed="thirstInputCountryChanged" :inputOptions="options"
                                 @input="thirstInputChanged" :autoDefaultCountry="true" id="store_phone"
                                 class="form-control form-control-solid" name="store_phone" v-model="formStore.phone"></vue-tel-input>
                </div>

                <div class="d-flex flex-column mb-8 fv-row">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('store.form.prefixe') }}</span>
                  </label>
                  <input type="text" required class="form-control form-control-solid" v-model="formStore.prefixe"
                         :placeholder="$t('store.form.prefixe')" />
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-sm btn-light" data-bs-target="#addStoresModal" data-bs-toggle="modal">{{
                      $t('button.close')
                    }}</button>
                  <button type="submit" class="btn btn-sm  btn-primary" :disabled="isLoading">
                    <span class="indicator-label" v-if="!isLoading">{{ $t('button.save') }}</span>
                    <span class="" v-else>{{ $t('loading') }}
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="modal fade" tabindex="-1" id="removeStoresModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('Shop.remove_stores_in_shop') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-2x"></span>
              </div>
            </div>

            <div class="modal-body">
              <form id="kt_modal_add_form" @submit.prevent="removeStoresInShopData" class="form" >
                <div class="form-group">
                  <label class="form-label">{{ $t('shop.select_stores') }}</label>
                  <select class="form-select form-select-solid kt_select2" data-control="select2"
                      v-model="formRemoveStoresToShopData.stores"  name="removeStores[]"
                      :data-placeholder="$t('shop.select_stores')" data-allow-clear="true" multiple="multiple">
                    <option></option>
                    <option v-for="store in stores_in_shop" :key="store.id" :value="store.id">{{ store.name }}</option>
                  </select>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
                  <button type="submit" id="kt_submit_remove_shop" class="btn btn-sm btn-primary fw-bolder">
                    <span class="indicator-label">{{ $t('button.save') }}</span>
                    <span class="indicator-progress">{{  $t('loading') }}
                  <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </template>

  <script>
  import {mapActions} from "vuex";
  import {BASE_URL} from "@/services/api";
  import { VueTelInput } from 'vue-tel-input';

  export default {
    name: "Users",
    props: {
      shop: {
        type: Object,
        default: {}
      }
    },
    components: { VueTelInput },
    data() {
      return {
        formAddStoresToShopData: {
          id: this.$route.params.id,
          stores: [],
        },
        formStoreDeleteData: {
          id: null,
          row: null
        },
        isLoading: false,
        shopData: {},
        stores: {},
        formStore: {
          id: '',
          name: '',
          address: '',
          phone: '',
          etat: 'active',
          prefixe: ''
        },
      }
    },

    watch:{
    '$i18n.locale' : function(value){
      if(value && this.table){
        this.$nextTick(() =>   this.fetchDatas())
      }
    },
    '$route.params.id' : function(newId, oldId){
      if (newId && newId !== oldId) this.initForShop()
    },
  },


    async mounted() {

      $(".kt_select2").select2()

      $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'addStores[]':
            let addStores = [];
            for (var k = 0, kLen = e.target.selectedOptions.length; k<kLen; k++) {
              if(e.target.selectedOptions[k].value != '' || e.target.selectedOptions[k].value != undefined){
                addStores.push(e.target.selectedOptions[k].value);
              }
            }
            this.formAddStoresToShopData.stores = addStores
            break;
          default:
            break;
        }
      });

      await this.initForShop()
      $(document).on("click", "#kt_datatable_shop_stores .delete_btn", (e) => {
        this.formStoreDeleteData.id = e.target.getAttribute('data-id')
        this.formStoreDeleteData.row = e.target.getAttribute('data-row')
        this.removeStoreRow()
      });

    },
    methods: {
      ...mapActions('shop', [
        'addShopStores',
        'showShop',
        'removeShopStore',
        'getStoresNotInShop'
      ]),

      ...mapActions('store', ['loadStore', 'createStore']),

      async initForShop() {
        this.fetchDatas()
        let response = await this.showShop(this.$route.params.id)
        this.shopData = response.data.shop
        let res = await this.getStoresNotInShop(this.$route.params.id)
        this.stores = res.data.stores
      },

      fetchDatas() {
        const AUTH_TOKEN = Ls.get('auth.token')

        this.table = $("#kt_datatable_shop_stores").DataTable({
          destroy: true,
          responsive: !0,
          searchDelay: 500,
          processing: !0,
          serverSide: !0,
          pageLength: Ls.get('pageLength') ?? 10,
          lengthMenu: [5, 10, 25, 50, 75, 100],
          order: [[0, 'desc']],
          ajax: {
            url: BASE_URL + '/get/shop/' + this.$route.params.id + '/stores/datatables',
            type: "GET",
            beforeSend: function (request) {
              request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
            },
            data: function (d) {

            }
          },
          columns: [{data: "name"},  {data: "Actions", responsivePriority: -1}],

          columnDefs: [
            {
              targets: -2,
              order: "desc",
              className: "dt-center clickable",
              render: function (t, a, e, l) {
                return '<span data-id="' + e.store_id + '" class="amountRow' + l.row + '">' + t + "</span>";
              },
            },
            {
              width: "10%",
              targets: -1,
              "className": "dt-center",
              title: "Actions",
              orderable: !1,
              render: (t, a, e, l) => {

                let render = ""
                if(!this.shopData.archive){
                  if(this.$can('boutique_store_config_delete')  ){
                    render+='<button type="button" data-row="'+ l.row +'" data-id="'+ e.store_id +'" class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto delete_btn">' +
                        '<i data-row="'+ l.row +'" data-id="'+ e.store_id +'" class="fa fa-trash-alt"></i>' +
                        '</button> '
                  }

                }
                return render

              },
            },

          ],
          language: {
            url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json",
          }
        });
      },

      openAddModal() {
        $('#addStoresModal').modal('toggle')
      },

      async addStoresInShopData() {
        this.$loading('kt_submit_add_store')

        let response = {}
        try {
          response = await this.addShopStores(this.formAddStoresToShopData)
          window.toastr['success'](i18n.global.t("notification.shop_add_stores_success"))
          this.table.ajax.reload()
          let res =  await this.getStoresNotInShop(this.$route.params.id)
          this.stores = res.data.stores
          $('#addStoresModal').modal('toggle')

          this.formAddStoresToShopData = {}

          this.$emit("reloadEditData")

          this.$stopLoading('kt_submit_add_store')
          return true
        }catch(err){
          this.$stopLoading('kt_submit_add_store')
          this.isLoading = false;
        }
      },

      async removeStoreRow() {
        let response = {}
        Swal.fire({
          title: i18n.global.t("notification.remove_store"),
          text: i18n.global.t("notification.irreversible_action"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Oui",
          cancelButtonText: "Non",
        }).then(async (result) => {
          if (result.value) {
            try {
              let data = {
                id: this.$route.params.id,
                store_id: this.formStoreDeleteData.id
              }
              response = await this.removeShopStore(data)
              window.toastr['success'](i18n.global.t("notification.shop_store_removed_success"))
              this.$emit("reloadEditData")
              let res =  await this.getStoresNotInShop(this.$route.params.id)
              this.stores = res.data.stores
              this.table.ajax.reload()
            } catch (e) {
              if (response && response.data) {
                window.toastr['error'](response.data.error)
                return true
              }
            }
          }
        });
      },

      thirstInputCountryChanged(country) {
        this.formStore.phone = '+' + country.dialCode
      },

      thirstInputChanged(number, phoneObject) {
        let errorDiv = document.querySelector('[data-field="shop_phone"][data-field="shop_phone"][data-validator="callback"]')
        if (errorDiv) {
          errorDiv.remove()
        }

        if (phoneObject) {
          this.formStore.phone = phoneObject.nationalNumber
          this.formStore.phone = '+' + phoneObject.countryCallingCode
        }
      },

      async createStoreData() {
        let response = {};
        console.log("here")
        this.isLoading = true;
        try {
          response = await this.createStore(this.formStore);
          $('#storeModal').modal('toggle')
          let res =  await this.getStoresNotInShop(this.$route.params.id)
          this.stores = res.data.stores
          this.openAddModal()
          window.toastr['success'](i18n.global.t('notification.store.created'))
          this.isLoading = false;
          this.formStore.name = "";
          this.formStore.address = "";
          this.formStore.phone = "";
          this.formStore.prefixe = "";
        } catch (err) {
          this.isLoading = false;
        }
      },
    },
  }
  </script>

  <style scoped>

  </style>
